/** Tailwind class constants for Manual Testing — no CSS/SCSS. */

export const mtView =
  'mx-auto box-border w-full min-w-0 max-w-[880px] px-6 pb-10 pt-6 max-md:px-4';

export const mtPageTitle =
  'mb-1.5 text-center text-xl font-bold text-[#1a1a1a]';

export const mtPageSub =
  'mb-7 text-center text-[0.9rem] leading-relaxed text-[#5a5a5a]';

export const mtCardWrap = 'mb-5';

export const mtTabsList =
  'mb-6 flex w-full items-stretch gap-0 rounded-none border-0 border-b border-solid border-[#e4e4e4] bg-transparent p-0';

export const mtTabTrigger =
  '-mb-px cursor-pointer rounded-none border-0 border-b-2 border-solid border-b-transparent bg-transparent px-4 pb-3 pt-1 text-[0.875rem] font-medium leading-none text-[#5a5a5a] shadow-none transition-[color,border-color] hover:text-[#1a1a1a] focus-visible:ring-offset-0 data-[state=active]:border-b-[#d85604] data-[state=active]:bg-transparent data-[state=active]:font-semibold data-[state=active]:text-[#1a1a1a] data-[state=active]:shadow-none';

export const mtTabContent = 'mt-0 outline-none';

export const mtCardTitle =
  'mb-5 border-b border-[#e4e4e4] pb-3 text-[0.7rem] font-bold uppercase tracking-[0.07em] text-[#5a5a5a]';

export const mtError =
  'mb-4 rounded border border-[#fecaca] bg-[#fef2f2] px-3.5 py-2.5 text-[0.8rem] text-[#dc2626]';

export const mtBtnRow =
  'mt-5 flex flex-wrap items-center justify-center gap-2.5';

export const mtBtnRowTop = 'mt-0 mb-5 justify-start';

export const mtContextCard =
  'rounded-md border border-[#e4e4e4] bg-[#f7f7f7] px-[1.125rem] py-3.5';

export const mtContextTitle =
  'mb-2.5 text-[0.7rem] font-bold uppercase tracking-[0.08em] text-[#5a5a5a]';

export const mtContextGrid =
  'grid grid-cols-2 gap-8 text-[0.825rem] text-[#1a1a1a]';

export const mtContentContainer = 'overflow-hidden text-ellipsis whitespace-nowrap';

export const mtContextLabel = 'mb-0.5 text-xs text-[#5a5a5a]';

export const mtModeGrid = 'grid grid-cols-2 gap-4';

export const mtModeCard =
  'relative rounded-lg border-2 border-[#e4e4e4] bg-white px-[1.375rem] py-[1.625rem] transition-[border-color,box-shadow] duration-150';

export const mtModeCardActive =
  'cursor-pointer hover:border-[#d85604] hover:shadow-[0_4px_20px_rgba(208,86,4,0.1)]';

export const mtModeCardDisabled =
  'cursor-not-allowed bg-[#f7f7f7] opacity-50';

export const mtModeTitle = 'mb-1.5 text-[0.9375rem] font-bold text-[#1a1a1a]';

export const mtModeDesc =
  'text-[0.8125rem] leading-[1.55] text-[#5a5a5a]';

export const mtModeBadge =
  'mt-3.5 inline-block rounded-[3px] border border-[#e4e4e4] bg-[#f0f0f0] px-2 py-0.5 text-[0.7rem] font-bold uppercase tracking-[0.06em] text-[#5a5a5a]';

export const mtWarn =
  'mb-5 rounded-md border border-[#fde68a] bg-[#fffbeb] px-[1.125rem] py-3.5';

export const mtWarnText =
  'text-[0.8125rem] leading-relaxed text-[#92400e] [&_strong]:text-[#78350f]';

export const mtDetailGrid =
  'grid grid-cols-2 gap-4 text-[0.8125rem] text-[#1a1a1a]';

export const mtDetailLabel =
  'mb-[3px] text-[0.7rem] uppercase tracking-[0.04em] text-[#5a5a5a]';

export const mtActiveWrap = 'py-8 text-center';

export const mtActiveTitle = 'mb-2 text-lg font-bold text-[#1a1a1a]';

export const mtActiveSub =
  'mx-auto mb-7 text-[0.8125rem] leading-[1.7] text-[#5a5a5a]';

export const mtSessionInfo =
  'mb-6 inline-flex min-w-[360px] flex-col gap-3 rounded-lg border border-[#e4e4e4] bg-white px-8 py-5 text-left';

export const mtSessionInfoRow =
  'flex items-baseline gap-4 text-[0.8125rem]';

export const mtSessionInfoLabel =
  'min-w-[72px] shrink-0 text-[0.7rem] font-semibold uppercase tracking-[0.06em] text-[#5a5a5a]';

export const mtSessionInfoValue =
  'break-all font-medium text-[#1a1a1a]';

export const mtSessionLink =
  'break-all text-[0.8125rem] text-[#2563eb] hover:underline';

export const mtSummaryGrid =
  'mb-5 grid grid-cols-1 overflow-hidden rounded-md border border-[#e4e4e4] bg-[#e4e4e4] gap-px';

export const mtSummaryGrid3col = 'grid-cols-2';

export const mtSummaryCell = 'bg-white p-[1.125rem] text-center';

export const mtSummaryN = 'font-mono text-[1.625rem] font-bold';

export const mtSummaryL =
  'mt-[3px] text-[0.625rem] uppercase tracking-[0.08em] text-[#5a5a5a]';

export const mtMetricsGrid = 'grid grid-cols-2 gap-3';

export const mtTagAskText =
  'm-0 text-sm leading-relaxed text-[#1a1a1a]';

export const mtRunningIcon = 'mb-[1.375rem] flex justify-center';

export const mtPulseDot =
  'h-[52px] w-[52px] animate-pulse rounded-full';

export const mtPulseDotRed = 'bg-[#dc2626]';

export const mtPulseDotGreen = 'bg-[#16a34a]';

export const adoTree =
  'mb-5 overflow-hidden rounded-md border border-[#e4e4e4] bg-white';

export const adoSuite = 'border-t border-[#e4e4e4] first:border-t-0';

export const adoSuiteHeader =
  'flex items-center justify-between bg-[#f7f7f7] px-3.5 py-2 text-[0.7rem] font-bold uppercase tracking-[0.06em] text-[#5a5a5a]';

export const adoSuiteCount =
  'rounded-[10px] bg-[#e4e4e4] px-1.5 py-px text-[0.65rem] text-[#5a5a5a]';

export const adoTc =
  'flex flex-col border-t border-[#f0f0f0] px-3.5 py-2 text-[0.8125rem] transition-colors duration-[120ms]';

export const adoTcBtn =
  'cursor-pointer hover:bg-[#fff8f5] focus:outline focus:outline-2 focus:outline-offset-[-2px] focus:outline-[#d85604]';

export const adoTcSelected =
  'border-l-[3px] border-l-[#d85604] bg-[#fff3eb] pl-[calc(0.875rem-3px)]';

export const adoTcPass = 'bg-[#f0fdf4]';

export const adoTcFail = 'bg-[#fef2f2]';

export const tcCheckItem =
  'flex w-full cursor-pointer select-none items-center gap-2';

export const tcCheckbox =
  'inline-flex h-4 w-4 shrink-0 cursor-pointer items-center justify-center rounded-[3px] border-2 border-solid border-[#c0c0c0] bg-white text-[10px] transition-[background,border-color] duration-[120ms]';

export const tcCheckboxChecked =
  'border-[#d85604] bg-[#d85604] text-white';

export const tcIdBadge =
  'shrink-0 whitespace-nowrap rounded-[3px] bg-[#f0f0f0] px-[5px] py-px font-mono text-[0.7rem] text-[#5a5a5a]';

export const tcTitle = 'min-w-0 flex-1 text-[#1a1a1a]';

export const tcInlineActions = 'mt-2.5 flex items-center gap-2.5 pl-[1.625rem]';

export const tcTagBtnPass =
  'h-8 min-w-[76px] rounded-md border-2 border-solid border-[#16a34a] bg-white px-4 text-[0.8125rem] font-semibold text-[#16a34a] shadow-none transition-colors hover:bg-[#f0fdf4] hover:translate-y-0 focus-visible:ring-[#16a34a]/30';

export const tcTagBtnPassActive =
  'border-[#16a34a] bg-[#16a34a] text-white hover:bg-[#15803d]';

export const tcTagBtnFail =
  'h-8 min-w-[76px] rounded-md border-2 border-solid border-[#dc2626] bg-white px-4 text-[0.8125rem] font-semibold text-[#dc2626] shadow-none transition-colors hover:bg-[#fef2f2] hover:translate-y-0 focus-visible:ring-[#dc2626]/30';

export const tcTagBtnFailActive =
  'border-[#dc2626] bg-[#dc2626] text-white hover:bg-[#b91c1c]';

export const tcInlineBtn =
  'cursor-pointer rounded-[3px] border bg-transparent px-2.5 py-0.5 text-[0.7rem] font-semibold transition-[background,color] duration-[120ms]';

export const tcInlineBtnPass =
  'border-[#16a34a] text-[#16a34a] hover:bg-[#16a34a] hover:text-white';

export const tcInlineBtnFail =
  'border-[#dc2626] text-[#dc2626] hover:bg-[#dc2626] hover:text-white';

export const tcInlineBtnPassActive = 'bg-[#16a34a] text-white';

export const tcInlineBtnFailActive = 'bg-[#dc2626] text-white';

export const mtPriorityBadge =
  'shrink-0 whitespace-nowrap rounded-[3px] px-[5px] py-px text-[0.65rem] font-bold';

export const mtPriorityBadgeP1 = 'bg-[#fef2f2] text-[#dc2626]';

export const mtPriorityBadgeP2 = 'bg-[#fffbeb] text-[#d97706]';

export const mtResultBadge =
  'shrink-0 whitespace-nowrap rounded-[3px] px-1.5 py-px text-[0.65rem] font-bold';

export const mtResultBadgePass = 'bg-[#f0fdf4] text-[#16a34a]';

export const mtResultBadgeFail = 'bg-[#fef2f2] text-[#dc2626]';

export const mtProgressStrip =
  'mb-5 flex items-center gap-2.5 overflow-y-auto rounded-md border border-[#e4e4e4] bg-[#f7f7f7] px-3.5 py-2.5';

export const mtProgItem = 'flex flex-col items-center gap-[3px]';

export const mtProgDot = 'h-2.5 w-2.5 rounded-full';

export const mtProgDotPass = 'bg-[#16a34a]';

export const mtProgDotFail = 'bg-[#dc2626]';

export const mtProgDotActive = 'animate-pulse bg-[#d85604]';

export const mtProgDotPending = 'bg-[#c0c0c0]';

export const mtProgId = 'font-mono text-[0.6rem] text-[#9a9a9a]';

export const mtProgRemaining =
  'ml-auto whitespace-nowrap text-xs text-[#5a5a5a]';

export const mtTcCard =
  'mb-5 rounded-lg border-2 border-[#d85604] bg-white px-[1.375rem] py-5';

export const mtTcCardHeader =
  'mb-4 flex flex-wrap items-center gap-2';

export const mtTcTitle = 'flex-1 text-[0.9rem] font-semibold text-[#1a1a1a]';

export const mtTcCaptureStatus =
  'mb-3.5 rounded bg-[#f7f7f7] p-2 text-center text-xs text-[#5a5a5a]';

export const mtBtnPass =
  'cursor-pointer rounded border-none bg-[#16a34a] px-8 py-2 text-[0.9rem] font-semibold text-white transition-opacity duration-150 hover:enabled:bg-[#15803d] disabled:cursor-not-allowed disabled:opacity-60';

export const mtBtnFail =
  'cursor-pointer rounded border-none bg-[#dc2626] px-8 py-2 text-[0.9rem] font-semibold text-white transition-opacity duration-150 hover:enabled:bg-[#b91c1c] disabled:cursor-not-allowed disabled:opacity-60';

export const mtResultBox =
  'mb-5 rounded-lg border-[3px] p-6 text-center font-mono text-[2.5rem] font-bold';

export const mtResultBoxPass =
  'border-[#16a34a] bg-[#f0fdf4] text-[#16a34a]';

export const mtResultBoxFail =
  'border-[#dc2626] bg-[#fef2f2] text-[#dc2626]';

export const mtResultsList = 'flex flex-col gap-1';

export const mtResultRow =
  'flex items-center gap-2 border-b border-[#f0f0f0] py-1.5 text-[0.8125rem] last:border-b-0';

export const mtResultRowTitle = 'min-w-0 flex-1 text-[#1a1a1a]';

/** Generic manual-testing test-case list styles (shared by ADO and GitHub flows). */
export const mtTcTree = adoTree;
export const mtTcSuite = adoSuite;
export const mtTcSuiteHeader = adoSuiteHeader;
export const mtTcSuiteCount = adoSuiteCount;
export const mtTcRow = adoTc;
export const mtTcRowBtn = adoTcBtn;
export const mtTcRowSelected = adoTcSelected;
export const mtTcRowPass = adoTcPass;
export const mtTcRowFail = adoTcFail;
